// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import cstmTable from "../../../../share/components/vue/PaginationTable";
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
const moment = require("moment");

/** 各フェーズ定義 */
const PHASE = {
  START: "start",
  LIST: "list",
  DETAIL: "detail",
  ALARM_DETAIL: "alarmDetail",
  OUTPUT_FILE: "outputFile",
  FAILED: "failed",
};

/** API type定義 */
const API_TYPE = {
  READ: 'read',
};

/** ボタンのクラス名 */
const buttonFontSizeOther = "button-font-size-other";

export default {
  name: "requirement076",
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      isDisableAlarmDetail: true,
      isDisableDetail: true,
      bodyItems: [],
      tableItems: [],
      // 一覧表示の縦の項目名
      columns: {
        item: this.$t(`individual.label_alarm_activation`),
        item1: this.$t(`individual.label_secondary_brake`),
        item2: this.$t(`individual.label_primary_brake`),
        item3: this.$t(`individual.label_inoperable`)
      },
      // 詳細表示の縦の項目名
      columnsParam: [
        this.$t(`individual.label_signal_item`),
        this.$t(`individual.label_signal_item1`),
        this.$t(`individual.label_signal_item2`),
        this.$t(`individual.label_signal_item3`),
        this.$t(`individual.label_signal_item4`),
        this.$t(`individual.label_signal_item5`),
        this.$t(`individual.label_signal_item6`),
        this.$t(`individual.label_signal_item7`),
        this.$t(`individual.label_signal_item8`),
        this.$t(`individual.label_signal_item9`),
        this.$t(`individual.label_signal_item10`),
        this.$t(`individual.label_signal_item11`),
        this.$t(`individual.label_signal_item12`),
        this.$t(`individual.label_signal_item13`),
        this.$t(`individual.label_signal_item14`),
        this.$t(`individual.label_signal_item15`),
        this.$t(`individual.label_signal_item16`),
        this.$t(`individual.label_signal_item17`),
        this.$t(`individual.label_signal_item18`),
        this.$t(`individual.label_signal_item19`),
        this.$t(`individual.label_signal_item20`),
        this.$t(`individual.label_signal_item21`),
        this.$t(`individual.label_signal_item22`)
      ],
      // 一覧表示用変数
      alarmActivationParams: null,
      secondaryBrakeParams: null,
      primaryBrakeParams: null,
      inoperableParams: null,
      // 作動履歴データ APIからのレスポンスそのまま 一時格納用
      responseUserData: [],
      // ソート済みファイル出力用データ
      outputFileData: null,
      // 一覧表示用データ
      listData: null,
      // 1次ブレーキ、2次ブレーキ、不動作の詳細表示用データ
      detailBrakeData: null,
      // 警報の詳細表示用データ
      detailAlarmData: null,
      modal_requirement_076: false
    };
  },

  props: {
    workSupportId: { type: Number, default: "", required: true }
  },

  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
          return "danger";
        case PHASE.START:
        case PHASE.LIST:
        case PHASE.DETAIL:
        case PHASE.ALARM_DETAIL:
        case PHASE.OUTPUT_FILE:
        default:
          return "secondary";
      }
    },

    modalSize() {
      switch (this.phase) {
        case PHASE.DETAIL:
        case PHASE.ALARM_DETAIL:
          return 'huge';
        default:
          return 'md';
      }
    },

    /** ボタンのクラスを判定 */
    checkButtonClassDetail() {
      switch (this.$parent.$i18n.locale) {
        case "en":
        case "zh":
        case "it":
        case "es":
        case "fr":
        case "de":
        case "ru":
          return buttonFontSizeOther;
        default:
          return "";
      }
    },
    checkButtonClassAlarmDetail() {
      switch (this.$parent.$i18n.locale) {
        case "it":
        case "es":
        case "fr":
          return buttonFontSizeOther;
        default:
          return "";
      }
    },

    listTableColumns() {
      this.tableItems = [
        {
          name: "itemName",
          label: `individual.label_table_item_trigger_type`,
        },
        {
          name: "itemValue",
          label: `individual.label_table_item_number`,
        }
      ];
      return this.tableItems;
    },
    detailTableColumns() {
      if (this.phase === PHASE.DETAIL) {
        this.tableItems = [
          {
            name: "itemName",
            label: `individual.label_detail_signal`,
          },
          {
            name: "itemValue",
            label: "message.header_vehice_ffd_unit"
          },
          {
            name: "itemValue1",
            label: `individual.label_detail_latest_time`
          },
          {
            name: "itemValue2",
            label: `individual.label_detail_latest_time_after`
          },
          {
            name: "itemValue3",
            label: `individual.label_detail_first_time`
          },
          {
            name: "itemValue4",
            label: `individual.label_detail_first_time_after`
          },
          {
            name: "itemValue5",
            label: `individual.label_detail_second_time`
          },
          {
            name: "itemValue6",
            label: `individual.label_detail_second_time_after`
          },
          {
            name: "itemValue7",
            label: `individual.label_detail_third_time`
          },
          {
            name: "itemValue8",
            label: `individual.label_detail_third_time_after`
          },
          {
            name: "itemValue9",
            label: `individual.label_detail_earliest_time`
          },
          {
            name: "itemValue10",
            label: `individual.label_detail_earliest_time_after`
          }
        ];
      } else {
        this.tableItems = [
          {
            name: "itemName",
            label: `individual.label_detail_signal`,
          },
          {
            name: "itemValue",
            label: "message.header_vehice_ffd_unit"
          },
          {
            name: "itemValue1",
            label: `individual.label_detail_latest_time`
          },
          {
            name: "itemValue2",
            label: `individual.label_detail_latest_time_after`
          },
          {
            name: "itemValue3",
            label: `individual.label_detail_first_time`
          },
          {
            name: "itemValue4",
            label: `individual.label_detail_first_time_after`
          },
          {
            name: "itemValue5",
            label: `individual.label_detail_second_time`
          },
          {
            name: "itemValue6",
            label: `individual.label_detail_second_time_after`
          },
          {
            name: "itemValue7",
            label: `individual.label_detail_third_time`
          },
          {
            name: "itemValue8",
            label: `individual.label_detail_third_time_after`
          },
          {
            name: "itemValue9",
            label: `individual.label_detail_fourth_time`
          },
          {
            name: "itemValue10",
            label: `individual.label_detail_fourth_time_after`
          },
          {
            name: "itemValue11",
            label: `individual.label_detail_fifth_time`
          },
          {
            name: "itemValue12",
            label: `individual.label_detail_fifth_time_after`
          },
          {
            name: "itemValue13",
            label: `individual.label_detail_sixth_time`
          },
          {
            name: "itemValue14",
            label: `individual.label_detail_sixth_time_after`
          },
          {
            name: "itemValue15",
            label: `individual.label_detail_seventh_time`
          },
          {
            name: "itemValue16",
            label: `individual.label_detail_seventh_time_after`
          },
          {
            name: "itemValue17",
            label: `individual.label_detail_eighth_time`
          },
          {
            name: "itemValue18",
            label: `individual.label_detail_eighth_time_after`
          },
          {
            name: "itemValue19",
            label: `individual.label_detail_earliest_time`
          },
          {
            name: "itemValue20",
            label: `individual.label_detail_earliest_time_after`
          }
        ];
      }
      return this.tableItems;
    },
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.modal_requirement_076 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_076 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 一覧画面にて表示する表の作成 */
    async start() {
      try {
        this.isLoading = true;

        // 読出し１回目
        if (!await this.doRead(1)) {
          return;
        }

        // 読出し２回目
        if (!await this.doRead(2)) {
          return;
        }

        // 読み出した結果を結合して１つにまとめる
        this.joinReadData();

        // 一覧表示
        this.showList();

      } finally {
        this.isLoading = false;
      }
    },

    /** 一覧画面制御 */
    listDisplaySetting() {
      // 警報詳細表示ボタン活性化
      if (this.listData.alarm > 0) {
        this.isDisableAlarmDetail = false;
      }

      // 1次/2次/不作動 詳細表示ボタン活性化
      if (this.listData.secondaryBrake > 0 || this.listData.primaryBrake > 0
        || this.listData.inoperable > 0) {
        this.isDisableDetail = false;
      }
    },

    /**
     * データ読出し
     * @param {number} readCount 呼び出し回数
     */
    async doRead(readCount) {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.READ,
        count: readCount
      };

      // read API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 読み出したデータを変数に保持する
            this.responseUserData.push(response.data.user_data);
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** 読出したデータを結合 */
    joinReadData() {
      let readData = [];
      this.listData = {
        alarm: 0,
        secondaryBrake: 0,
        primaryBrake: 0,
        inoperable: 0
      };
      this.detailAlarmData = [];
      let readCount = 0;

      for (const userData of this.responseUserData) {
        // ファイル出力用データ
        readData = readData.concat(userData.read_results);

        // 一覧表示用データ
        const readListData = userData.list_data;
        this.listData.alarm += readListData.alarm;
        this.listData.secondaryBrake += readListData.secondary_brake;
        this.listData.primaryBrake += readListData.primary_brake;
        this.listData.inoperable += readListData.inoperable;

        // 1次ブレーキ、2次ブレーキ、不動作の詳細表示用データ
        if (userData.detail_data_brake) {
          this.detailBrakeData = userData.detail_data_brake;
        }

        // 警報の詳細表示用データ
        if (userData.detail_data_alarm) {
          let detailRowCount = 0;
          for (const item of userData.detail_data_alarm) {
            if (readCount === 0) {
              const row = {};
              row.unit = item.unit;
              row.old = item.old;
              row.old_05 = item.old_05;
              row.eight = item.eight;
              row.eight_05 = item.eight_05;
              this.detailAlarmData.push(row);
            } else {
              const row = this.detailAlarmData[detailRowCount];
              row.seven = item.seven;
              row.seven_05 = item.seven_05;
              row.six = item.six;
              row.six_05 = item.six_05;
              row.five = item.five;
              row.five_05 = item.five_05;
              row.four = item.four;
              row.four_05 = item.four_05;
              row.three = item.three;
              row.three_05 = item.three_05;
              row.two = item.two;
              row.two_05 = item.two_05;
              row.one = item.one;
              row.one_05 = item.one_05;
              row.new = item.new;
              row.new_05 = item.new_05;
              detailRowCount++;
            }
          }
        }

        readCount++;
      }

      // ファイル出力用データをDIDの昇順に並び替え
      readData.sort(this.compareFunction);
      this.outputFileData = readData;
    },

    /**
     * sortの比較関数
     * @param {object} a 比較対象１つ目
     * @param {object} b 比較対象２つ目
     */
    compareFunction(a, b) {
      // DIDの昇順
      return a.id - b.id;
    },

    /** 一覧表示用データを作成 */
    makeDispListData() {
      this.alarmActivationParams = this.listData.alarm ? this.listData.alarm : "-";
      this.secondaryBrakeParams = this.listData.secondaryBrake ? this.listData.secondaryBrake : "-";
      this.primaryBrakeParams = this.listData.primaryBrake ? this.listData.primaryBrake : "-";
      this.inoperableParams = this.listData.inoperable ? this.listData.inoperable : "-";

      this.$nextTick(() => {
        this.bodyItems = [
          {
            itemID: 0,
            itemName: this.columns.item,
            itemValue: this.alarmActivationParams
          },
          {
            itemID: 1,
            itemName: this.columns.item1,
            itemValue: this.secondaryBrakeParams
          },
          {
            itemID: 2,
            itemName: this.columns.item2,
            itemValue: this.primaryBrakeParams
          },
          {
            itemID: 3,
            itemName: this.columns.item3,
            itemValue: this.inoperableParams
          }
        ];
      });
    },

    /** 一覧表示 */
    showList() {
      this.phase = PHASE.LIST;

      // 一覧表示用データを作成
      this.makeDispListData();

      // 画面制御
      this.listDisplaySetting();
    },

    /** 詳細表示 (警告表示・1次/2次/不作動ボタン押下時の処理) */
    showDetail() {
      const showData = [];
      // phase更新時にDOM更新が行われるのでnextTickより前に移動
      this.phase = PHASE.DETAIL;
      // リスト表示項目の設定
      let idx = 0;
      this.detailBrakeData.forEach(element => {
        const item = {
          itemID: idx,
          itemName: this.columnsParam[idx],
          itemValue: element.unit !== undefined ? element.unit : "-",
          itemValue1: element.new !== undefined ? element.new : "-",
          itemValue2: element.new_05 !== undefined ? element.new_05 : "-",
          itemValue3: element.one !== undefined ? element.one : "-",
          itemValue4: element.one_05 !== undefined ? element.one_05 : "-",
          itemValue5: element.two !== undefined ? element.two : "-",
          itemValue6: element.two_05 !== undefined ? element.two_05 : "-",
          itemValue7: element.three !== undefined ? element.three : "-",
          itemValue8: element.three_05 !== undefined ? element.three_05 : "-",
          itemValue9: element.old !== undefined ? element.old : "-",
          itemValue10: element.old_05 !== undefined ? element.old_05 : "-"
        };
        // 全データをテーブル表示に使用できる形にまとめる
        showData.push(item);
        idx++;
      });
      // テーブルに表示する内容確定
      this.$nextTick(() => {
        this.bodyItems = showData;
      });
    },

    /** 詳細表示 (警告表示ボタン押下時の処理) **/
    showAlarmDetail() {
      const showData = [];
      // phase更新時にDOM更新が行われるのでnextTickより前に移動
      this.phase = PHASE.ALARM_DETAIL;
      let idx = 0;
      // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
      /* eslint-disable complexity */
      this.detailAlarmData.forEach(element => {
        const item = {
          itemID: idx,
          itemName: this.columnsParam[idx],
          itemValue: element.unit !== undefined ? element.unit : "-",
          itemValue1: element.new !== undefined ? element.new : "-",
          itemValue2: element.new_05 !== undefined ? element.new_05 : "-",
          itemValue3: element.one !== undefined ? element.one : "-",
          itemValue4: element.one_05 !== undefined ? element.one_05 : "-",
          itemValue5: element.two !== undefined ? element.two : "-",
          itemValue6: element.two_05 !== undefined ? element.two_05 : "-",
          itemValue7: element.three !== undefined ? element.three : "-",
          itemValue8: element.three_05 !== undefined ? element.three_05 : "-",
          itemValue9: element.four !== undefined ? element.four : "-",
          itemValue10: element.four_05 !== undefined ? element.four_05 : "-",
          itemValue11: element.five !== undefined ? element.five : "-",
          itemValue12: element.five_05 !== undefined ? element.five_05 : "-",
          itemValue13: element.six !== undefined ? element.six : "-",
          itemValue14: element.six_05 !== undefined ? element.six_05 : "-",
          itemValue15: element.seven !== undefined ? element.seven : "-",
          itemValue16: element.seven_05 !== undefined ? element.seven_05 : "-",
          itemValue17: element.eight !== undefined ? element.eight : "-",
          itemValue18: element.eight_05 !== undefined ? element.eight_05 : "-",
          itemValue19: element.old !== undefined ? element.old : "-",
          itemValue20: element.old_05 !== undefined ? element.old_05 : "-"
        };
        // 全データをテーブル表示に使用できる形にまとめる
        showData.push(item);
        idx++;
      });
      // テーブルに表示する内容確定
      this.$nextTick(() => {
        this.bodyItems = showData;
      });
    },

    /** ファイル保存 */
    async saveOperationHistory() {
      let stream = null;
      let outputData = "";
      try {
        // ファイル名指定
        const fileDate = moment().format("YYYYMMDDHHmmss");

        // ファイル保存ダイアログを開く
        const options = {
          suggestedName: fileDate + ".csv",
          types: [
            {
              description: this.$t(
                `individual.label_file_text_ws76`
              ),
              accept: {
                "text/csv": [".csv"]
              }
            }
          ],
          excludeAcceptAllOption: true,
          multiple: false
        };
        const fh = await window.showSaveFilePicker(options);

        // ファイル保存
        stream = await fh.createWritable();

        // 出力内容設定
        outputData = this.setOutputContent();

        const blob = new Blob([outputData], {
          type: "text/csv"
        });
        await stream.write(blob);
      } catch (e) {
        // ファイル出力がキャンセルされた場合等は、ファイル保存せずreturnする
        return;
      } finally {
        if (stream !== null) {
          await stream.close();
        }
        this.showList();
      }
    },

    /** 出力内容設定
     * @returns 出力データ
     */
    setOutputContent() {
      let writeData = "";

      // CSVの行数を取得
      let rowLength = 0;
      for (const item of this.outputFileData) {
        if (rowLength < item.value.length) {
          rowLength = item.value.length;
        }
      }

      for (let i = 0; i <= rowLength - 2; i += 2) {
        let lineData = "";
        for (const item of this.outputFileData) {
          if (i + 2 <= item.value.length) {
            const byteData = item.value.substring(i, i + 2);
            lineData += ("," + byteData);
          } else {
            lineData += ",";
          }
        }
        // 先頭のカンマを削除
        lineData = lineData.substring(1) + "\n";
        writeData += lineData;
      }

      return writeData;
    },

    /** 一覧表示 保存ボタン押下時処理 */
    async onclickSave() {
      this.phase = PHASE.OUTPUT_FILE;
      await this.saveOperationHistory();
    },

    /** 一覧表示 1次/2次/不作動詳細表示ボタン押下時処理 */
    onDetailClicked() {
      this.showDetail();
    },

    /** 一覧表示 警報詳細表示ボタン押下時処理 */
    onAlarmDetailClicked() {
      this.showAlarmDetail();
    },

    /** 詳細表示 戻るボタン押下時処理 */
    clickBack() {
      this.showList();
    },
  },

  async mounted() {
    this.init();
    this.start();
  }
};
